import React, { Component } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import Image from 'components/Common/Image'
import offerPageURL from 'lib/offer/offerPageURL'
import ClickableLink from 'components/Common/Clickable/ClickableLink'
import Caption from 'components/Luxkit/Typography/Caption'
import BodyText from 'components/Luxkit/Typography/BodyText'

const StyledImage = styled(Image)`
  max-width: 100%;
`

const SlideHeader = styled.div`
  position: relative;
  flex: 1;
  margin-left: ${rem(5)};
  min-height: ${rem(90)};

  > * + * {
    margin-top: ${rem(2)};
  }
`

const InnerWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.neutral.default.five};
  padding: ${rem(12)};
  display: flex;

  &.selected {
    border: 1px solid ${({ theme }) => theme.palette.brand.primary.normal};
  }
`

interface Props {
  offer: App.Offer | App.OfferSummary;
  selected: boolean;
  onProductClick: (offerId: string) => void;
}

class CarouselItem extends Component<React.PropsWithChildren<Props>> {
  render() {
    const {
      offer,
      selected,
      onProductClick,
    } = this.props

    const {
      image,
      name,
      locationHeading,
      locationSubheading,
    } = offer

    return <ClickableLink
      to={offerPageURL(offer)}
      onClick={(e) => {
        e.preventDefault()
        onProductClick(offer.id)
      }}
      preventSwipeClick
      onDragStart={e => { e.preventDefault(); return false }}
      target="_blank"
    >
      <InnerWrapper className={selected && 'selected'}>
        <StyledImage id={image.id} width={120} alt={name} aspectRatio="4:3" draggable={false} />
        <SlideHeader>
          {(locationHeading || locationSubheading) &&
            <>
              <Caption variant="medium" as="span">{locationHeading || locationSubheading}</Caption>
              {locationHeading && locationSubheading &&
                <Caption variant="medium" as="span" colour="neutral-three">{` - ${locationSubheading}`}</Caption>
              }
            </>
          }
          <BodyText variant="medium" weight="bold">{name}</BodyText>
        </SlideHeader>
      </InnerWrapper>
    </ClickableLink>
  }
}

export default CarouselItem
